import React from 'react';

import { View, Text, StyleSheet } from '@react-pdf/renderer';

interface InfoProps {
  name: string;
  value: string;
}

interface InfoListProps {
  infos: InfoProps[];
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  info: {
    flexDirection: 'column',
  },
  infoName: {
    fontWeight: 700,
  },
});

export const Info: React.FC<InfoProps> = ({ name, value }) => (
  <View style={styles.info}>
    <Text style={styles.infoName}>{name}:</Text>
    <Text>{value}</Text>
  </View>
);

const InfoList: React.FC<InfoListProps> = ({ infos = [] }) => {
  return (
    <View style={styles.container}>
      {infos.map(info => (
        <Info name={info.name} value={info.value} />
      ))}
    </View>
  );
};

export default InfoList;
